export interface StudyDateSeriesLike {
  acquisition_datetime?: string | null
}

interface ParsedStudyDate {
  key: number
  date: Date
}

function buildStudyDate(year: number, month: number, day: number): ParsedStudyDate | null {
  if (!(Number.isInteger(year) && Number.isInteger(month) && Number.isInteger(day))) {
    return null
  }
  if (month < 1 || month > 12 || day < 1 || day > 31) return null

  const local = new Date(year, month - 1, day, 12, 0, 0, 0)
  if (local.getFullYear() !== year || local.getMonth() !== month - 1 || local.getDate() !== day) {
    return null
  }

  return {
    key: year * 10000 + month * 100 + day,
    date: local
  }
}

function parseStudyDate(raw: string): ParsedStudyDate | null {
  const value = raw.trim()
  if (!value) return null

  const compactMatch = /^(\d{4})(\d{2})(\d{2})$/.exec(value)
  if (compactMatch) {
    const year = Number.parseInt(compactMatch[1]!, 10)
    const month = Number.parseInt(compactMatch[2]!, 10)
    const day = Number.parseInt(compactMatch[3]!, 10)
    return buildStudyDate(year, month, day)
  }

  const isoDatePrefixMatch = /^(\d{4})-(\d{2})-(\d{2})(?:[T\s]|$)/.exec(value)
  if (isoDatePrefixMatch) {
    const year = Number.parseInt(isoDatePrefixMatch[1]!, 10)
    const month = Number.parseInt(isoDatePrefixMatch[2]!, 10)
    const day = Number.parseInt(isoDatePrefixMatch[3]!, 10)
    return buildStudyDate(year, month, day)
  }

  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return null
  return buildStudyDate(parsed.getFullYear(), parsed.getMonth() + 1, parsed.getDate())
}

export function deriveEarliestStudyDate(series: StudyDateSeriesLike[], locale?: Intl.LocalesArgument): string | null {
  let earliest: ParsedStudyDate | null = null

  for (const item of series) {
    if (!item.acquisition_datetime) continue
    const parsed = parseStudyDate(item.acquisition_datetime)
    if (!parsed) continue
    if (!earliest || parsed.key < earliest.key) {
      earliest = parsed
    }
  }

  if (!earliest) return null

  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric"
  }).format(earliest.date)
}
